import type { ComponentsArticleReview } from 'queries/graphql';

import { Review } from './components/Review';

import styles from './styles.module.sass';

export default function Reviews({
  sectionId,
  heading,
  subheading,
  reviews = [],
}: ComponentsArticleReview) {
  return (
    <div id={sectionId} className={styles.reviews}>
      <div>
        {heading && <div className={styles.heading}>{heading}</div>}
        {subheading && <div className={styles.subheading}>{subheading}</div>}
      </div>
      <div className={styles.grid}>
        {reviews.map(review => (
          <Review key={review.id} {...review} />
        ))}
      </div>
    </div>
  );
}
